"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarthCatapult = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var EarthCatapult = (function (_super) {
    __extends(EarthCatapult, _super);
    function EarthCatapult() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.EARTH_CATAPULT,
            tags: [Tags_1.Tags.EARTH],
            cost: 23,
            cardDiscount: { amount: 2 },
            metadata: {
                cardNumber: '070',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a card, you pay 2 M€ less for it.', function (eb) {
                        eb.empty().startEffect.megacredits(-2);
                    });
                }),
                victoryPoints: 2,
            },
        }) || this;
    }
    EarthCatapult.prototype.getCardDiscount = function () {
        return 2;
    };
    EarthCatapult.prototype.play = function () {
        return undefined;
    };
    EarthCatapult.prototype.getVictoryPoints = function () {
        return 2;
    };
    return EarthCatapult;
}(Card_1.Card));
exports.EarthCatapult = EarthCatapult;
